<template>
  <div class ="hotMap">
    <myMap :fillCitys="fillCitys" :center="center" :Pzoom="5" :hotData="hotData" :g="g" :mapStyle="mapStyle" :max="250"></myMap>
    <div class="process">
      <div>{{maxTime?st(maxTime).substring(0, st(maxTime).length-5) + '00:00':st(new Date())}}</div>
      <div class="left">
        <el-slider v-model="state" :show-tooltip="false"></el-slider>
      </div>
      <div class="play" @click="play"><i class="el-icon-video-pause" v-show="played===true"></i><i class="el-icon-video-play" v-show="played===false"></i></div>
    </div>
  </div>
</template>

<script>
import myMap from '@/components/timeData/myMap.vue'
import { stringTime } from '../../../common/js/commont.js'
import MixinWL from '../../../store/wl/mixinsWl.js'
import { message } from 'ant-design-vue'

export default {
  mixins: [MixinWL],
  components: {
    myMap
  },
  data () {
    return {
      fillCitys: null,
      params: 'PM2.5',
      state: 0,
      sits: '',
      codes: '',
      played: false,
      hotData: [],
      center: '扬州',
      Index: 0,
      Length: 0,
      pence: 0,
      timeDate: null,
      minTime: '',
      maxTime: '',
      hotArr: null,
      mapStyle: {
        styleJson: [
          {
            featureType: 'land',
            elementType: 'all',
            stylers: {
              color: '#5DA5BB'
            }
          },
          {
            featureType: 'highway',
            elementType: 'all',
            stylers: {
              color: '#5DA5BB'
            }
          },
          {
            featureType: 'river',
            elementType: 'all',
            stylers: {
              color: '#5DA5BB'
            }
          },
          {
            featureType: 'railway',
            elementType: 'all',
            stylers: {
              color: '#5DA5BB'
            }
          },
          {
            featureType: 'sea',
            elementType: 'all',
            stylers: {
              color: '#eee'
            }
          }
        ]
      },
      g: {
        0.14: 'rgba(255,255,255,0.4)',
        0.3: 'rgba(82,219,117,1)',
        0.6: 'rgba(82,219,117,1)',
        0.8: 'rgba(255,135,25,1)',
        1: 'rgba(226,95,95,0.1)'
      }
    }
  },
  methods: {
    st (value) {
      return stringTime(value)
    },
    play () {
      if (this.played) {
        clearInterval(this.timerId)
        this.played = false
      } else {
        if (this.Index === this.length) {
          this.Index = 0
        }
        this.played = true
        this.timerId = setInterval(() => {
          this.Index++
          if (this.Index === this.length) {
            clearInterval(this.timerId)
            this.played = false
            this.Index = 0
          }
        }, 15 * 1000 / this.length)
      }
    },
    // 获取点位和坐标
    getMapinfo () {
      this.hide = message.loading('获取点位中,请稍后操作...', 0)
      var ts = stringTime(new Date())
      this.updateTime = ts
      var data = {
        token: window.localStorage.getItem('token'),
        account: window.localStorage.getItem('account'),
        ts
      }
      // 这段代码是为了将地图划分并配置数据
      this.getMapInfo(data).then(value => {
        this.sits = []
        this.codes = []
        // var towns = []
        value.list.forEach(item => {
          var li = {
            lng: parseFloat(item.lng),
            lat: parseFloat(item.lat),
            code: item.code,
            town: item.town,
            count: item['PM2.5']
          }
          this.sits.push(li)
          this.codes.push(item.code)
          // 创建分区---------------------不用可以删除
          /*
          if (towns.indexOf(item.town) === -1) {
            towns.push(item.town)
          }
          */
        })
        // 用于分配区域----------------------不用可以删除
        /*
        if (towns.length) {
          // 随机配置以后可以删除
          this.fillCitys = [
            {
              name: '宝应县',
              color: 'green',
              value: 0
            },
            {
              name: '江都区',
              color: 'green',
              value: 0
            },
            {
              name: '高邮市',
              color: 'green',
              value: 0
            },
            {
              name: '仪征市',
              color: 'green',
              value: 0
            }
          ]
          towns.forEach(town => {
            this.fillCitys.push({
              name: town,
              color: 'green',
              value: 0
            })
          })
        }
        */
        this.hotData = this.sits
        this.getHistoryData()
      }).catch(e => {
        this.$message.warning(e.message)
      })
    },
    // 获取历史数据
    getHistoryData () {
      var ts = stringTime(new Date())
      var data = {
        account: window.localStorage.getItem('account'),
        codes: this.codes.join(','),
        datetype: 'H',
        max_time: stringTime(new Date()),
        min_time: stringTime(new Date(new Date().getTime() - (1000 * 60 * 60 * 24 * 3))),
        params: this.params,
        token: window.localStorage.getItem('token'),
        ts
      }
      this.getHistoryDeviceLog(data).then(value => {
        this.hotArr = value
        this.length = value[this.sits[0].code].length
        this.pence = 100 / this.length
        this.configHot(value)
        this.hide()
      })
    },
    // 配置数据-----没用到
    configIndex (value) {
      // 随机配置以后可以删除
      this.hotData = []
      this.timeDate = []
      // 循环所有点位---------------------------------------
      this.sits.forEach(sit => {
        // 判断设备是否有数据------------------------------------------
        if (value[parseInt(sit.code)].length) {
          value[parseInt(sit.code)].forEach(time => {
            this.timeDate.push(time.time)
          })
          // 计算步骤条分多少块------------------------------------------
          this.Length = value[parseInt(sit.code)].length
          // 计算步骤条每块长度----------------------------------------
          this.pence = 100 / this.Length
          // 判断步骤条所在长度位置对应是否有数据--------------------------
          if (value[parseInt(sit.code)][this.Index]) {
            // 计算数值为当前索引的参数值--------------------------
            sit.count = parseFloat(value[parseInt(sit.code)][this.Index][this.params])
          }
          // 添加热力点位---------------------------------------------
          this.hotData.push({
            lng: sit.lng,
            lat: sit.lat,
            count: sit.count,
            town: sit.town
          })
        }
      })
      this.fillCitys.forEach(city => {
        // 每个区域下的设备分类
        city.sit = []
        // 为了将同一区的数据归类
        this.hotData.forEach(item => {
          if (item.town === city.name) {
            city.sit.push(item)
          }
        })
        // 计算同一区域平均值
        city.sit.forEach(item => {
          city.value += item.count
          if (isNaN(city.value)) {
            city.value = 0
          }
        })
        city.value = parseInt(city.value / city.sit.length)
        // 如果当前点位的数值小于当前当前区域的平局值则去掉
        this.hotData.forEach((item, index) => {
          if (item.count < city.value) {
            this.hotData.splice(index, 1)
          }
        })
      })
    },
    // 这段是为了将获取的历史数据分配到站点下
    configHot (value) {
      if (this.sits) {
        this.sits.forEach(sit => {
        // 如果有数据的话就设置数据没数据就为0
          if (value[sit.code]) {
            if (value[sit.code].length) {
              sit.count = value[sit.code][this.Index][this.params]
            } else {
              sit.count = 0
            }
          } else {
            sit.count = 0
          }
        })
        this.hotData = this.sits
      }
    }
  },
  created () {
    this.getMapinfo()
  },
  mounted () {

  },
  watch: {
    Index (value) {
      this.$nextTick(() => {
        this.state = this.pence * value
        this.configHot(this.hotArr)
      })
    },
    state (value) {
      this.$nextTick(() => {
        this.Index = Math.round(value / this.pence)
      })
    }
  }
}
</script>

<style lang='less' scoped>
.hotMap {
  height: 100%;
  width: 100%;
  position:relative;
  .process{
    position:absolute;
    bottom:0rem;
    left:0rem;
    width:100%;
    height:1rem;
    display:flex;
    align-items:center;
    background:rgba(0,0,0,0.6);
    justify-content:space-around;
    .left{
      width:60%;
      height:4px;
    }
  }
}
.play{
  cursor:pointer;
  font-size: 0.4rem;
}
.wind{
      width:1.2rem;
      height:1.2rem;
      position:absolute;
      right: 0.24rem;
      top: 0.24rem;
      background:url(../../../assets/img/windB.png);
      background-size:cover;
      img{
        height:50%;
        width: 0.2rem;
        position:absolute;
        top:25%;
        left:0.5rem;
      }
    }
</style>
